// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2YHg2","content":"styles_content__1vr2I","checkbox":"styles_checkbox__2e86A","checkboxLabel":"styles_checkboxLabel__1s3Zs"};